
//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/list'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/popover'
import 'devextreme/ui/toolbar'
import 'devextreme/viz/chart'
import 'devextreme/viz/pie_chart'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { IUserSession } from '../../../helpers/user-session'
import { ChartDirectiveController } from './chart.directive.controller'
import { IMeasurementsService } from '../../common/measurements/measurements.service'
import { SYSTEM_SERVICE_NAME, SystemService } from '../../../services/system'
import { StateService } from "@uirouter/angularjs";

import './chart.scss'
import * as TEMPLATE from './chart.tpl.html'

export class ChartDirective implements ng.IDirective {
    scope = {
        data: '=',
        itemTitle: '=',
        fitToScreen: '=?',
        isEditMode: '=',
        backgroundColor: '=?',
        dashboardModel: '='
    }

    restrict = 'E'
    controller = [
        '$scope',
        '$timeout',
        '$element',
        '$state',
        '$q',
        'api',
        'localDictionary',
        'userSession',
        'measurements',
        SYSTEM_SERVICE_NAME,
        (
            $scope: any,
            $timeout: ng.ITimeoutService,
            $element: JQuery,
            $state: StateService,
            $q: ng.IQService,
            api: Api,
            localDictionary: LocalDictionaryFactory,
            userSession: IUserSession,
            measurements: IMeasurementsService,
            systemService: SystemService
        ) => new ChartDirectiveController($scope, $timeout, $element, $state, $q, api, localDictionary, userSession, measurements, systemService)]
    template = TEMPLATE
    transclude = true
    replace = true
}